// extracted by mini-css-extract-plugin
export default {"container":"Ko-z","brandName":"Lo-z","productName":"Mo-z","productNamePdpEnhancements":"No-z","breakLongProductName":"Oo-z"};